import { html, css, LitElement } from 'lit';
import { NexusComponent } from "./nexus.component";

class TicketsStepsContainerComponent extends NexusComponent {
    static shadowRootOptions = { ...LitElement.shadowRootOptions, mode: 'open', delegatesFocus: true };
    static properties = {
        step: {
            type: Number,
            attribute: 'step',
            reflect: true,
        },
    };
    constructor() {
        super();
        this.step;
        this.addEventListener('click', this.handleClick);
    }
    static get styles() {
        // Write styles in standard CSS
        // https://stackoverflow.com/questions/25193964/how-can-i-have-a-web-components-width-and-height-be-inherited-by-its-children
        return css`
			:host {
                display: block;  /* or display: block; */
                position: relative;
                margin: 0;
			}
		`;
    }

    handleSlotChange(event) {
        console.log('handleSlotChange', event);
        // this.limit();
        this.activate('1');
    }

    limit() {
        let count = 0;
        this._slottedChildren.forEach((child) => {
            if (child.localName === 'tickets-step') {
                count += 1;
            }
        });

        // console.log('counted', count);
        let ticketsNavigation = this.closest('tickets-navigation');
        ticketsNavigation.setAttribute('maximumSteps', count);
        // console.log('ticketsNavigation', ticketsNavigation);
    }

    activate(value) {
        let steps = this.querySelectorAll('tickets-step');
        // console.log('Steps', steps);

        steps.forEach((child) => {
            child.removeAttribute('current'); // reset
        });
        this.limit();
        steps.forEach((child) => {
            if (child.getAttribute('step') == value.toString()) {
                child.setAttribute('current', '');
            }
        });
    }

    attributeChangedCallback(name, _old, value) {
        super.attributeChangedCallback(name, _old, value);
        // console.log('attributeChangedCallback', name, _old, value);
        // console.log(this._slottedChildren);
        this.activate(value);
    }

    get _slottedChildren() {
        const slot = this.shadowRoot.querySelector('slot');
        return slot.assignedElements({ flatten: true });
    }

    /**
     * 
     * @param {Event} event 
     */
    handleClick(event) {
        console.log('handleClick', event);
    }

    render() {
        return html`
            <div class="tickets-steps-container" component-loaded>
                <slot @slotchange="${this.handleSlotChange}">...</slot>
                
            </div>
        `;
        // Step debug: ${this.step}
    }
}

window.customElements.define('tickets-steps-container', TicketsStepsContainerComponent);